export const GlobalVariable = Object.freeze({
  BASE_TYPEOFESTUDIOS: 1,
  BASE_API_URL:"https://josspe-api.centralmed.com.ar/",
  BASE_FRONT_URL:"https://josspe.centralmed.com.ar/",
});
